/*
 * Novicell master
 *  Author: APN modified by DLA
 *  Use this file to call functions in other files, on document ready, window.resize etc.
 *  ------
 * Dependencies: jquery, novicell.js, other files with awesome functions.
 *  Usage: $(function () {
 *              projectName.slider.heroSlider($('.owl-carousel'));
 *         }); // Document ready end
 */

var novicell = novicell || {};
var prongHorn = prongHorn || {};


$.fn.emulateTransitionEnd = function (duration) {
    var called = false, $el = this
    $(this).one($.support.transition.end, function () { called = true })
    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
    setTimeout(callback, duration)
    return this
};


// Document ready
$(function () {
    // Only include Novicell functions that you use!
    novicell.responsive.init();
    novicell.responsiveLazyloadImage.image();
    // novicell.adjustFigureImage.init();
    // novicell.lazyload.content();
    // novicell.lazyload.image();
    prongHorn.navigation.collapseMenu('#header');
    prongHorn.navigation.offCanvasMenu('[data-offcanvas-trigger]', '#right-offcanvas', $('#toolbar').data('navurl'));
    prongHorn.navigation.showSearch();
    prongHorn.slider.initImageSlider('.image-slider--product');
    prongHorn.slider.initDefault('.hero-slider');
    // prongHorn.slider.initProductSlider('.product-list__container--slider');
    prongHorn.variantPicker.init();
    prongHorn.productUpgrade.init();
    // prongHorn.fixedElement.reCalc();

    prongHorn.cart.init();
    prongHorn.product.init();
    prongHorn.presentation.init();
    prongHorn.deliverypopup.init();
    prongHorn.cookieWarning.init();

    // Call new functions here like this:
    svg4everybody(); // Fix SVG spritemap in IE/Edge
    $('[data-toggle="tooltip"]').tooltip();

}); // Document ready end


/*
 *  Use the following if needed
 */

// Window load
// $(window).load(function(e){
//     // call functions here
// }); // Window load

// Window resize
$(window).resize(function(e){
    // prongHorn.fixedElement.reCalc();
    novicell.responsiveLazyloadImage.onResize();
}); // Window resize

// Window scroll
$(window).scroll(function(e){
/*    if($(window).width() > 992)
        prongHorn.fixedElement.init(); */

    if($('.responsiveLazyload').length > 0)
        novicell.responsiveLazyloadImage.image();
}); // Window scroll